// components/ServiceForm/ServiceForm.tsx
import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
} from '@mui/material';
import { ServiceFormData, ServiceFormProps } from '../../../types/services.types';
import { serviceFormStyles } from './ServiceForm.styles';

const ServiceForm: React.FC<ServiceFormProps> = ({ service, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState<ServiceFormData>({
    name: service?.name || '',
    service_code: service?.service_code || '',
  });

  const handleSubmit = (): void => {
    onSubmit(formData);
  };

  const handleChange = (field: keyof ServiceFormData) => (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  return (
    <Box sx={serviceFormStyles.container}>
      <Box sx={serviceFormStyles.fieldContainer}>
        <Typography variant="body2" sx={serviceFormStyles.label}>
          Service Name
        </Typography>
        <TextField
          fullWidth
          value={formData.name}
          onChange={handleChange('name')}
          placeholder="Enter service name"
          variant="outlined"
          size="small"
          sx={serviceFormStyles.textField}
        />
      </Box>

      <Box sx={serviceFormStyles.fieldContainer}>
        <Typography variant="body2" sx={serviceFormStyles.label}>
          Service Code
        </Typography>
        <TextField
          fullWidth
          value={formData.service_code}
          onChange={handleChange('service_code')}
          placeholder="Enter service code"
          variant="outlined"
          size="small"
          sx={serviceFormStyles.textField}
        />
      </Box>

      <Box sx={serviceFormStyles.buttonContainer}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={serviceFormStyles.submitButton}
          fullWidth
        >
          {service ? 'Update' : 'Create'} Service
        </Button>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={serviceFormStyles.cancelButton}
          fullWidth
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default ServiceForm;